import { Chip, ChipProps, styled } from "@mui/material";

/**
 * Variant of Chip
 */
export const StatusChip = styled(Chip)<ChipProps>(({ theme }) => ({
  width: "fit-content",
  display: "inline-flex",
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  lineHeight: 1,
  "& .MuiChip-label": {
    padding: 0,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.pxToRem(14),
  },
  "&.MuiChip-outlined .MuiChip-label": {
    color: theme.palette.text.primary,
  },
  "&.MuiChip-sizeSmall": {
    height: "16px",
    "& .MuiChip-label": {
      fontSize: theme.typography.pxToRem(13),
    },
  },
  "&.MuiChip-sizeTiny": {
    height: "13px",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    "& .MuiChip-label": {
      fontSize: theme.typography.pxToRem(11),
    },
  },
}));
